import * as React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const DeleteConfirmDialog = ({
  open,
  logonId,
  loading,
  onCancel,
  onConfirm,
}) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onCancel}
    maxWidth="xs"
    fullWidth
  >
    <DialogContent sx={{ textAlign: "center", padding: "36px 32px 28px" }}>
      <WarningAmberIcon sx={{ fontSize: 64, color: "#f5a623", mb: 1 }} />
      <Typography
        sx={{
          color: "#f5a623",
          fontWeight: 700,
          fontSize: "20px",
          mb: 2,
        }}
      >
        Delete Logon ID
      </Typography>
      <Typography sx={{ color: "#555", fontSize: "15px" }}>
        Are you sure you want to delete this Logon ID
        {logonId ? ` "${logonId}"` : ""}?
      </Typography>
    </DialogContent>
    <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 4, pt: 1 }}>
      <Button
        onClick={onCancel}
        disabled={loading}
        variant="outlined"
        sx={{
          textTransform: "none",
          borderRadius: "4px",
          minWidth: 100,
          fontWeight: 600,
        }}
      >
        No
      </Button>
      <Button
        onClick={onConfirm}
        disabled={loading}
        variant="contained"
        sx={{
          textTransform: "none",
          borderRadius: "4px",
          minWidth: 100,
          fontWeight: 600,
          backgroundColor: "#3299ff",
        }}
      >
        {loading ? "Deleting..." : "Yes"}
      </Button>
    </DialogActions>
  </Dialog>
);

DeleteConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  logonId: PropTypes.string,
  loading: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DeleteConfirmDialog.defaultProps = {
  logonId: "",
  loading: false,
};

export default DeleteConfirmDialog;
